/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

var data = [];

var push = function push(value) {
  data.push(value);
};

var pop = function pop() {
  data.pop();
};

var stack = {
  push: push,
  pop: pop,

  get top() {
    return data[data.length - 1];
  }

};

export { stack as default };
//# sourceMappingURL=stack.js.map
